import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../lib/api.service';
import { LogService } from '../../../lib/log.service';
import { Organization } from '../../../models/organization';

/**
 * Manually pair a user with a counselor. Reached from the "Create Association"
 * button on the admin user listing's Counselor Sync tab, which previously just
 * routed to the generic create-user form.
 */
@Component({
    selector: 'create-association',
    templateUrl: './create-association.html',
    styleUrls: ['./create-association.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CreateAssociation implements OnInit {
    associationForm: FormGroup;
    organizations: Organization[] = [];
    isSaving = false;
    errorMessage = '';

    constructor(
        private api: ApiService,
        private log: LogService,
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<CreateAssociation>
    ) {
        this.associationForm = this.formBuilder.group({
            userEmail: ['', [Validators.required, Validators.email]],
            counselorEmail: ['', [Validators.required, Validators.email]],
            orgId: [null, Validators.required],
        });
    }

    ngOnInit() {
        this.api.get('admin/organizations').subscribe(
            (results: any) => {
                this.organizations = Organization.initializeArray(results.data);
            },
            (error: any) => {
                this.log.error('Error loading. ' + error.message);
            }
        );
    }

    get f() {
        return this.associationForm.controls;
    }

    close() {
        this.dialogRef.close(false);
    }

    save() {
        this.errorMessage = '';

        if (this.associationForm.invalid) {
            this.associationForm.markAllAsTouched();
            return;
        }

        this.isSaving = true;
        this.api
            .post('admin/counselorpairings', this.associationForm.value)
            .subscribe(
                (result: any) => {
                    this.isSaving = false;
                    // Tell the caller to refresh the listing.
                    this.dialogRef.close(true);
                },
                (error: any) => {
                    this.isSaving = false;
                    this.errorMessage =
                        error && error.message
                            ? error.message
                            : 'Something went wrong. Please try again.';
                }
            );
    }
}
